import { loadableReady } from '@loadable/component';
import * as Sentry from '@sentry/react';
import 'idempotent-babel-polyfill';
import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/en-gb';
import React from 'react';
import { render } from 'react-dom';
import 'url-search-params-polyfill';
import App, { LandingApp } from './App';
import { getLang, isLocal } from './utils/utils';
import { NETWORK_ERROR_MESSAGE } from './utils/api';
import {
  isUnattributableNetworkRejection,
  scrubBreadcrumb,
  scrubEvent,
  TRACE_PROPAGATION_TARGETS,
} from './utils/sentryFilters.jsx';
import './i18n.js';

moment.locale(getLang().moment);

if (typeof window !== 'undefined') window.abUserType = 'A';

if (!isLocal()) {
  Sentry.init({
    dsn:
      'https://73fcbb4b685464137a989e6a458c6053@o4507419326611456.ingest.de.sentry.io/4507420475261008',
    allowUrls: [/.*\.roulezjeunesse\.com.*/],
    // Performance tracing. tracePropagationTargets adds sentry-trace + baggage
    // headers on requests to the API so front transactions link to their
    // backend transactions (distributed tracing).
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    tracePropagationTargets: TRACE_PROPAGATION_TARGETS,
    ignoreErrors: [
      // Unhandled XHR ProgressEvent rejections from third-party SDKs
      // (Klaviyo, Stripe, analytics, etc.) when their endpoints are blocked
      // by adblockers or fail with status 0. No stacktrace, so allowUrls
      // can't filter them.
      /Non-Error promise rejection captured/,
      /Event `\w+`.*captured as promise rejection/,
      // XHR transport failures. callAPI no longer reports them (see
      // utils/api.jsx), this is the net for any other caller that surfaces
      // one — deleteClient, mainly. Message-only, so it belongs here rather
      // than in the structural beforeSend filter; anchored so a real API
      // message merely mentioning a network still reports.
      new RegExp(`^${NETWORK_ERROR_MESSAGE}$`),
    ],
    beforeBreadcrumb: scrubBreadcrumb,
    beforeSend(event) {
      return isUnattributableNetworkRejection(event) ? null : scrubEvent(event);
    },
    beforeSendTransaction: scrubEvent,
  });
}

window.dataLayer = window.dataLayer || [];

if (typeof window !== 'undefined' && typeof window.dataLayer !== 'undefined') {
  window.dataLayer.push({
    event: 'pageview',
    url: window.location.pathname + window.location.search,
    originalLocation: `${document.location.protocol}//${
      // needed for fake location
      document.location.hostname
    }${document.location.pathname}${document.location.search}`,
  });
  window.dataLayer.push({
    pageview: window.location.pathname + window.location.search,
  });
}

const [subdomain] = window.location.hostname.split('.');
const landingDomains = [
  'darty',
  'fnac',
  'ratp',
  'quizz',
  'communautes',
  'localhosts',
  'inscription',
  'clientscdiscount',
];
const partnerDomains = ['decathlon', 'cdiscount', 'localhosts']; // cobranding

if (landingDomains.includes(subdomain)) {
  const subD = subdomain === 'localhost' ? 'decathlon' : subdomain;
  loadableReady(() => {
    render(
      <LandingApp subdomain={subD} />,
      document.querySelectorAll('._home')[0],
    );
  });
} else {
  let partenaire = partnerDomains.includes(subdomain) ? subdomain : '';
  if (partenaire === 'localhost') {
    partenaire = 'decathlon';
  }

  loadableReady(() => {
    render(
      <App partenaire={partenaire} />,
      document.querySelectorAll('._home')[0],
    );
  });
}
